import './forms.css'
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import Button from 'elements/CustomButton/CustomButton.jsx'
import { renderField } from './_fieldRenderer'

class DiscountConditionForm extends React.Component {

    render() {
        const { handleSubmit, submitting } = this.props

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Field
                                name='name'
                                type='text'
                                component={renderField}
                                label='Nome'
                                placeholder='Nome'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={4}>
                        <FormGroup>
                            <Field
                                name='eneleDiscount'
                                type='number'
                                component={renderField}
                                label='Desconto Enele (%)'
                                placeholder='Apenas números'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={4}>
                        <FormGroup>
                            <Field
                                name='nubeDiscount'
                                type='number'
                                component={renderField}
                                label='Desconto Nube (%)'
                                placeholder='Apenas números'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='danger'
                            type='button'
                            disabled={submitting}
                            onClick={this._handleCancel}
                            wd
                        >
                            Cancelar
                         </Button>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='default'
                            type='submit'
                            disabled={submitting}
                            fill
                        >
                            Salvar
                         </Button>
                    </Col>
                </Row>
            </form >
        )
    }

    _handleCancel = () => {
        this.props.reset() //form reset - redux-form action creator
        this.props.handleCancel() //function passed via props
    }

}

const validate = values => {
    const errors = {}
    if (!values.name) { errors.name = 'Obrigatório' }
    if (!values.eneleDiscount) { errors.eneleDiscount = 'Obrigatório' }
    else if (values.eneleDiscount <= 0) { errors.eneleDiscount = 'Deve ser maior que zero' }
    if (!values.nubeDiscount) { errors.nubeDiscount = 'Obrigatório' }
    else if (values.nubeDiscount <= 0) { errors.nubeDiscount = 'Deve ser maior que zero' }

    return errors
}

DiscountConditionForm = reduxForm({ form: 'DiscountConditionForm', validate })(DiscountConditionForm)
export default DiscountConditionForm



// WEBPACK FOOTER //
// ./src/forms/DiscountConditionForm.jsx